import styled, { css } from 'styled-components';
import OutlinedButton from 'components/layout/form/outlinedButton';
import { Modal } from 'react-bootstrap';

type ModalProps = {
  typeModal: string;
}

export const Container = styled.div`
  padding-bottom: 20px;
`;

export const Button = styled(OutlinedButton)`
  outline: none !important;
`;

export const ModalComponent = styled(Modal)<ModalProps>`
  .modal-content {
    border-radius: 12px;
    width: 600px;
    min-height: 512px;

    ${({ typeModal }) =>
      typeModal === 'success' &&
      css`
        width: 370px;
        min-height: 292px;
      `}

    @media (max-width: 632px) {
      width: 472px;
      min-height: 592px;

      ${({ typeModal }) =>
        typeModal === 'success' &&
        css`
          width: 370px;
          min-height: 328px;
        `}
    }

    @media (max-width: 480px) {
      width: 432px;
    }

    @media (max-width: 440px) {
      width: 400px;
    }

    @media (max-width: 412px) {
      width: 300px;
      min-height: 600px;

      ${({ typeModal }) =>
        typeModal === 'success' &&
        css`
          width: 370px;
          min-height: 328px;
        `}
    }
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: 600px;
    }
  }

  @media (min-width: 992px) {
    .modal-lg,
    .modal-xl {
      max-width: 500px;
    }
  }

  @media (max-width: 632px) {
    .modal-dialog {
      max-width: 478px;
    }

    @media (max-width: 480px) {
      .modal-dialog {
        max-width: 435px;
      }
    }

    @media (max-width: 440px) {
      .modal-dialog {
        max-width: 405px;
      }
    }

    @media (max-width: 412px) {
      .modal-dialog {
        max-width: 300px;
      }
    }
  }
`;
